var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId,
    stroke: "#2329D6",
    strokeWidth: 1,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    fill: "none",
    color: "#2329D6",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "notebookIconTitle"
  }, "Notebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "notebookIconTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8h5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3v18H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 19v-1a1 1 0 0 1 1-1h12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebook);
export default __webpack_public_path__ + "static/media/notebook.db586b690ff1a7a45235e9259f16b0ee.svg";
export { ForwardRef as ReactComponent };